module.exports = __webpack_public_path__ + "img/voucher_icon_3.faf755f6.svg";